import { useQuery } from '@tanstack/react-query';
import { SSF } from '~/apis/api';
import { createQueryKeySet } from '~/utils/query-keys';

export const keys = createQueryKeySet<number>('club_admins');

export function useClubAdminListQuery(clubId: number) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.clubsListClubAdminsList(clubId);
      return data;
    },
    queryKey: keys.list(clubId),
  });
}
